import toast from 'react-hot-toast';
import { gstAPI } from '../../services/api';
import { msg } from './gstUi';

// Auth is header-only, so a plain link can't open the PDF: fetch a blob and show it.
export async function openPdf(callRaw, kind, id) {
  const w = window.open('', '_blank'); // opened synchronously so popup blockers allow it
  try {
    const r = await callRaw(() => gstAPI.pdf(kind, id));
    const url = URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' }));
    if (w) w.location.href = url; else window.open(url, '_blank');
    setTimeout(() => URL.revokeObjectURL(url), 120000);
  } catch (e) {
    if (w) w.close();
    toast.error(e.response?.status === 423 ? 'Locked' : msg(e));
  }
}
